import styles from './LoadingScreen.module.css'

interface LoadingScreenProps {
  message?: string
}

export function LoadingScreen({ message }: LoadingScreenProps) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img
          src="/assets/logo.webp"
          alt="Heracomm"
          className={styles.logo}
        />
        <div className={styles.progressTrack}>
          <div className={styles.progressBar} />
        </div>
        <p className={styles.text}>{message || 'Caricamento...'}</p>
      </div>
    </div>
  )
}







